// client/src/api/categoriaProductos.js
import api from "./config.js";

    // Obtener todas las categorías
    export const getCategorias = async () => {
    const { data } = await api.get("/categorias");
    return Array.isArray(data) ? data : data.categorias || [];
    };

    // Obtener una categoría por ID
    export const getCategoria = async (id) => {
    const { data } = await api.get(`/categorias/${id}`);
    return data.categoria || data;
    };

    // Crear nueva categoría
    export const createCategoria = async (categoria) => {
    const { data } = await api.post("/categorias", categoria);
    return data;
    };

    // Actualizar categoría
    export const updateCategoria = async (id, categoria) => {
    const { data } = await api.put(`/categorias/${id}`, categoria);
    return data;
    };

    // Eliminar categoría
    export const deleteCategoria = async (id) => {
    const { data } = await api.delete(`/categorias/${id}`);
    return data;
    };
